import axios from 'axios';
import RouteUrls from '../common/RouteUrls';
import {getAuthToken, getXSRFToken} from '../common/authTokenUtil';

export const changeExpiringPassword = async (orgName, loginName, currentPassword, newPassword) => {
  try {
    const response = await axios({

      method: 'POST',
      url: RouteUrls.EXPIRING_PASSWORD_CHANGE,
      headers: {
        'Authorization': `Bearer ${getAuthToken()}`,
        'correlation-id':
          '12345',
        'client-id':
          'PNET',
        'device-id': '12345'
      },

      data: {
        organizationNumber: orgName,
        loginName: loginName,
        currentPassword: currentPassword,
        newPassword: newPassword,
      }

    });


    return response.data;

  } catch (error) {
    throw error;
  }
}
